var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_3292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 14.4375H16.3125V12.375H14.9375V14.4375H12.875V15.8125H14.9375V17.875H16.3125V15.8125H18.375V14.4375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625 20.625C12.6 20.625 10.125 18.15 10.125 15.125C10.125 12.1 12.6 9.625 15.625 9.625C18.65 9.625 21.125 12.1 21.125 15.125C21.125 18.15 18.65 20.625 15.625 20.625ZM15.625 11C13.3563 11 11.5 12.8563 11.5 15.125C11.5 17.3938 13.3563 19.25 15.625 19.25C17.8938 19.25 19.75 17.3938 19.75 15.125C19.75 12.8563 17.8938 11 15.625 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 4.125C19.75 3.36875 19.1313 2.75 18.375 2.75H15.625V1.375H14.25V2.75H8.75V1.375H7.375V2.75H4.625C3.86875 2.75 3.25 3.36875 3.25 4.125V17.875C3.25 18.6313 3.86875 19.25 4.625 19.25H8.75V17.875H4.625V4.125H7.375V5.5H8.75V4.125H14.25V5.5H15.625V4.125H18.375V8.25H19.75V4.125Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_3292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5d3b7feabe627d5f3d9f8fd123014a2c.svg";
export { ForwardRef as ReactComponent };